import * as equipment from "./equipment";
import * as hostScreenPermission from "./hostScreenPermission";
import * as xueLing from "./xueLing";

const apiObj = { equipment, hostScreenPermission, xueLing };

const install = function(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.defineProperties(Vue.prototype, {
    $api: {
      get() {
        return apiObj;
      },
    },
  });
};

export default {
  install,
};
